import React, { Suspense } from 'react';
import { withRouter } from 'react-router';

import {
  Loader,
} from '../../components';

import './leaflet.css';
import './style.scss';

const ProjectMap = (props) => {
  // Lazy-load ProjectMap with a delay.
  const ProjectMap = React.lazy(() => {
    return new Promise((resolve) => {
      setTimeout(() => resolve(import('./Map')), 1500);
    });
  });

  return (
    <Suspense fallback={<Loader inline loading />}>
      <ProjectMap {...props} />
    </Suspense>
  );
};

export default withRouter(ProjectMap);
